// src/pages/offlineSales/terminal/components/HoldOrdersDrawer.jsx
import React from 'react';
import { X, RotateCcw } from 'lucide-react';
import { useLocalization } from '../../../../contexts/LocalizationContext';
import styles from '../OfflineSalesTerminal.module.css';

const HoldOrdersDrawer = ({ holdOrders, onRecall, onClose }) => {
  const { t, formatCurrency } = useLocalization();

  const formatTime = (iso) => {
    try {
      return new Date(iso).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    } catch {
      return '';
    }
  };

  return (
    <div className={styles.drawerOverlay} onClick={onClose}>
      <div className={styles.drawer} onClick={e => e.stopPropagation()}>
        <div className={styles.drawerHeader}>
          <h3>{t('pos.holdOrders')}</h3>
          <button onClick={onClose} className={styles.modalClose}><X size={18} /></button>
        </div>

        {holdOrders.length === 0 ? (
          <div className={styles.drawerEmpty}>{t('pos.noHoldOrders')}</div>
        ) : (
          <div className={styles.holdList}>
            {holdOrders.map(held => (
              <div key={held.id} className={styles.holdCard}>
                <div className={styles.holdCardInfo}>
                  <span className={styles.holdOrderNumber}>{held.label}</span>
                  <span className={styles.holdCustomer}>
                    {held.customer?.name || t('pos.cashSales')}
                  </span>
                  <span className={styles.holdItems}>
                    {held.itemCount} {t('pos.items')} · {formatCurrency(held.grandTotal)}
                    {held.heldAt && <> · {formatTime(held.heldAt)}</>}
                  </span>
                </div>
                <button
                  className={styles.recallBtn}
                  onClick={() => onRecall(held)}
                  title={t('pos.recallOrder')}
                >
                  <RotateCcw size={16} />
                  <span>{t('pos.recallOrder')}</span>
                </button>
              </div>
            ))}
          </div>
        )}

        <div className={styles.drawerFooter}>
          <small>{t('pos.holdOrderNote')}</small>
        </div>
      </div>
    </div>
  );
};

export default HoldOrdersDrawer;
